import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-semi-interpenetrating-network-disclosure',
  templateUrl: './semi-interpenetrating-network-disclosure.component.html',
  styleUrls: ['./semi-interpenetrating-network-disclosure.component.scss']
})
export class SemiInterpenetratingNetworkDisclosureComponent implements OnInit {
  @ViewChild('semiInterpenetratingNetworkDisclosureInput') semiInterpenetratingNetworkDisclosureInput!: ElementRef;
  semiInterpenetratingNetworkDisclosure!: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.semiInterpenetratingNetworkDisclosure = this.currentForm.get('semiInterpenetratingNetworkDisclosure')?.value;
  }

  public clearSemiInterpenetratingNetworkDisclosureInputField() {
    this.semiInterpenetratingNetworkDisclosure = '';
    this.currentForm.patchValue({'semiInterpenetratingNetworkDisclosure': ''});
  }

  public updateSemiInterpenetratingNetworkDisclosure(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.semiInterpenetratingNetworkDisclosure = '';
      }
    }
    this.currentForm.patchValue({'semiInterpenetratingNetworkDisclosure': this.semiInterpenetratingNetworkDisclosure});
  }

  public cancelUpdate() {
    this.semiInterpenetratingNetworkDisclosure = this.currentForm.get('semiInterpenetratingNetworkDisclosure')?.value;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

}
